import { Stack, styled } from '@mui/material';

export const RoundedBorderStack = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 4,
}));
